import { ChevronRight } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  useTheme,
  Typography,
  Link,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import GridContainer from "../../components/grid/GridContainer.jsx";
import GridItem from "../../components/grid/GridItem.jsx";
import { AuthContext } from "../../context/AuthContext.jsx";
import { getLeranMoreStyle } from "../../components/customstyles/LearnMoreStyle.jsx";
import { useHistory, useLocation } from "react-router-dom";

const useStyles = () => {
  let theme = useTheme();
  return getLeranMoreStyle(theme);
};

function Breadcrumbs(props) {
  const styles = useStyles();
  const [loadingStarted, setLoading] = useState(true);
  const [patientName, setPatientName] = useState(null);
  const { makeAuthenticatedApiCall } = useContext(AuthContext);
  const history = useHistory();

  const location = useLocation();
  const getPatientId = () => {
    let patientId;
    let pathname = location.pathname.substring(1);
    pathname = pathname.split("/");
    patientId = pathname[1];
    return { patientId };
  };

  useEffect(() => {
    let { patientId } = getPatientId();
    const fetchPatientData = async () => {
      try {
        let patientDetailsResponse = await makeAuthenticatedApiCall(
          "get",
          `/api/userservice/getpatientdetails/${patientId}`,
          {}
        );
        if (patientDetailsResponse?.status === 200) {
          const patientData = patientDetailsResponse.data;
          setPatientName(patientData.patientName);
        }
      } catch (error) {
        console.error("Error fetching patient data:", error);
      } finally {
        props.handleLoading();
        setLoading(false);
      }
    };
    fetchPatientData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const nameWithEllipsis = (name, maxLength = 25) => {
    const truncatedName =
      name.length > maxLength ? name.slice(0, maxLength) + "..." : name;
    return truncatedName;
  };

  return (
    <Box>
      {loadingStarted ? (
        <Box sx={styles.loadingCoverageStyle}>
          <Box sx={{ marginBottom: "20px" }}>
            <CircularProgress />
          </Box>
          <Typography sx={styles.loadinText}>Loading...</Typography>
        </Box>
      ) : (
        <GridContainer>
          <GridItem lg={12} md={12} sm={12} xs={12} sx={{ marginTop: "15px" }}>
            <Box sx={styles.headerStyle}>
              <Link
                onClick={() => history.push(`/patients`)}
                sx={styles.pointerCss}
              >
                <Typography variant="body1" sx={{ color: "#0D47A1" }}>
                  Patients List
                </Typography>
              </Link>
              <ChevronRight />
              <Link
                onClick={() =>
                  history.push(`/patients/${getPatientId().patientId}/1`)
                }
                sx={styles.pointerCss}
              >
                <Typography variant="body1" sx={{ color: "#0D47A1" }}>
                  {patientName}
                </Typography>
              </Link>
              <ChevronRight />
              <Link
                onClick={() =>
                  history.push(`/patients/${getPatientId().patientId}/2`)
                }
                sx={styles.pointerCss}
              >
                <Typography variant="body1" sx={{ color: "#0D47A1" }}>
                  Learn More
                </Typography>
              </Link>
              <ChevronRight />
              <Typography variant="p">
                {nameWithEllipsis(props.name)}
              </Typography>
            </Box>
          </GridItem>
        </GridContainer>
      )}
    </Box>
  );
}

export default Breadcrumbs;
